// extracted by mini-css-extract-plugin
export default {"small_hero":"HeroSmall_small_hero__Wik-Z","small_hero_content":"HeroSmall_small_hero_content__kMyYB"};